var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "showPanel",
      staticClass: "text-copy",
      class: { "box-focus": _vm.isShow },
      on: { click: _vm.handleCopy },
    },
    [
      _c(
        "div",
        { staticClass: "body" },
        [
          _c("span", { staticClass: "pl10" }, [_vm._v(_vm._s(_vm.text))]),
          _vm.isShow
            ? _c(
                "el-link",
                {
                  directives: [
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:copy",
                      value: _vm.text,
                      expression: "text",
                      arg: "copy",
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:error",
                      value: function () {
                        _vm.msgError("复制失败")
                      },
                      expression:
                        "\n        () => {\n          msgError('复制失败')\n        }\n      ",
                      arg: "error",
                    },
                    {
                      name: "clipboard",
                      rawName: "v-clipboard:success",
                      value: function () {
                        _vm.msgSuccess("复制成功")
                      },
                      expression:
                        "\n        () => {\n          msgSuccess('复制成功')\n        }\n      ",
                      arg: "success",
                    },
                  ],
                  staticClass: "copy-btn mr10",
                  attrs: { underline: false },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return function () {}.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "el-icon-view el-icon-copy-document",
                  }),
                  _vm._v("复制 "),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }